import WorldMap from '../assets/images/World Map.svg'
import CityStats from './CityStats';
import {useTheme} from '../context/ThemeContext';
import '../App.css'
export default function Location() {
    const {theme} = useTheme();
    return (
        <div className={` ${theme === '#1c1c1c' ? 'bg-[#282828]' : 'bg-[#f7f9fb]'} p-4 w-[200px] h-[318px] rounded-xl hover:scale-105 transition-transform`}>
        <p className="text-sm my-bold p-2 -mt-2">Revenue by Location</p>
        <img src={WorldMap} alt="World Map" className="w-full h-auto" />
        <CityStats/>
        </div>
    );
}